import axios from "axios";

export const getDataTableTransaksiMasuk = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/transaksiMasuk/dataTable?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/transaksiMasuk/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getDataTransMasuk = async (
  searchText = null,
  offset = 0,
  limit = 0,
  sortingCol = 0,
  sortingMode = "DESC"
) => {
  if (searchText) {
    return await axios.get(
      `${window._HOST}admin/transaksiMasuk/transMasuk?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  } else {
    return await axios.get(
      `${window._HOST}admin/transaksiMasuk/transMasuk?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`,
      { withCredentials: true }
    );
  }
};

export const getFilteredTransaksiMasuk = async (condition) => {
  return await axios.post(
    `${window._HOST}admin/transaksiMasuk/filteredData`,
    condition,
    { withCredentials: true }
  );
};

export const insertNewTransaksiMasuk = async (formData) => {
  return await axios.post(`${window._HOST}admin/transaksiMasuk/`, formData, {
    withCredentials: true,
  });
};

export const deleteTransaksiMasuk = async (id_transaksi_masuk) => {
  return await axios.delete(
    `${window._HOST}admin/transaksiMasuk/${id_transaksi_masuk}`,
    { withCredentials: true }
  );
};

export const updateTransaksiMasuk = async (id_transaksi_masuk, formData) => {
  return await axios.post(
    `${window._HOST}admin/transaksiMasuk/${id_transaksi_masuk}`,
    formData,
    { withCredentials: true }
  );
};

export const getNomorTransaksiMasuk = async () => {
  return await axios.get(`${window._HOST}admin/transaksiMasuk/noTransMasuk`, {
    withCredentials: true,
  });
};

export const importCSVTransaksiMasuk = async (formData) => {
  return await axios.post(
    `${window._HOST}admin/transaksiMasuk/importCSV/`,
    formData,
    {
      withCredentials: true,
    }
  );
};

export const exportSpesifikTransaksiMasuk = async () => {
  return await axios.get(`${window._HOST}/admin/transaksiMasuk/specificData`, {
    withCredentials: true,
  });
};
